import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { toastr } from 'react-redux-toastr';
import cn from 'classnames';
import { AlertBox } from '../Shared/Alerts';
import { appInsights } from '../../utils/applicationInsights';

import styles from './CreateMeasurementModal.module.scss';
import SvgBarcodeliga from '../../shared/icons/osstell-light/BarcodeLiga';

import ISQItem from './ISQItem';
import Modal from '../Shared/Modal/Modal';
import { Button } from '../Shared/Buttons';
import { InputItem, InputRow, InputSubGroup } from '..//Shared/Forms/';
import gs1Parser from '../../modules/gs1-parser';

import * as patientActions from '../../redux/actions/patientActions';
import * as instrumentActions from '../../redux/actions/instrumentActions';
import * as generalActions from '../../redux/actions/generalActions';
import IsqInfoModal from './IsqInfoModal';
import { toastrOptions } from '../../constants/toastrOptions';

class CreateMeasurementModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isqBl: '',
      isqMd: '',
      updatedDir: undefined,
      nextDir: undefined,
      level: 'Implant',
      timeStamp: undefined,
      selectedOption: undefined,
      instrumentId: undefined,
      instrumentIdMeasured: undefined,
      insertionTorque: undefined,
      session: undefined,
      loadingProtocol: 'NoSelection',
      surgicalProtocol: 'NoSelection',
      smartPegType: 'NoSelection',
      finalRestoration: false,
      smartPegLot: '',
      errorMessages: undefined,
    };

    this.intl = props.intl;

    this.hideCreateMeasurementModal = this.hideCreateMeasurementModal.bind(this);

    this.sessionChanged = this.sessionChanged.bind(this);
    this.isqChanged = this.isqChanged.bind(this);
    this.levelChanged = this.levelChanged.bind(this);
    this.timeStampChanged = this.timeStampChanged.bind(this);
    this.saveMeasurement = this.saveMeasurement.bind(this);
    this.deleteMeasurement = this.deleteMeasurement.bind(this);
    this.deleteMeasurementRequest = this.deleteMeasurementRequest.bind(this);
    this.insertionTorqueChanged = this.insertionTorqueChanged.bind(this);
    this.loadingProtocolChanged = this.loadingProtocolChanged.bind(this);
    this.surgicalProtocolChanged = this.surgicalProtocolChanged.bind(this);
    this.smartPegTypeChanged = this.smartPegTypeChanged.bind(this);
    this.finalRestorationChanged = this.finalRestorationChanged.bind(this);
    this.lotChanged = this.lotChanged.bind(this);
    this.boundOnScan = this.onScan.bind(this);

    this.createMeasurement = false;
    this.deletingMeasurement = false;

    this.sessionOptions = [
      {
        key: 'Placement',
        value: this.intl.formatMessage({
          id: 'measurement.placement',
          defaultMessage: 'Placement',
        }),
      },
      {
        key: 'Followup',
        value: this.intl.formatMessage({ id: 'measurement.followup', defaultMessage: 'Follow up' }),
      },
    ];

    this.levelOptions = [
      {
        key: 'Implant',
        value: this.intl.formatMessage({ id: 'measurement.implant', defaultMessage: 'Implant' }),
      },
      {
        key: 'Abutment',
        value: this.intl.formatMessage({ id: 'measurement.abutment', defaultMessage: 'Abutment' }),
      },
    ];

    this.restorationOptions = [
      {
        key: 'Yes',
        value: this.intl.formatMessage({ id: 'general.yes', defaultMessage: 'Yes' }),
      },
      {
        key: 'No',
        value: this.intl.formatMessage({ id: 'general.no', defaultMessage: 'No' }),
      },
    ];
  }

  componentDidMount() {
    if (window.ReactNativeWebView) {
      window.addEventListener('barcode', this.boundOnScan, true);
    }

    if (this.props.show && this.props.implant) {
      let type = undefined;
      if (this.props.measurement?.type === 'DuringPlacement') type = 'Placement';
      else if (
        this.props.measurement?.type === 'DuringFollowup' ||
        this.props.measurement?.type === 'DuringLoading'
      )
        type = 'Followup';
      this.setState({
        session: type,
        finalRestoration: this.props.measurement
          ? this.props.measurement.type === 'DuringLoading'
          : this.props.implant.measurements.some((x) => x.type === 'DuringLoading'),
        loadingProtocol: this.props.implant.loadingProtocol,
        surgicalProtocol: this.props.implant.surgicalProtocol,
        insertionTorque: this.props.implant.insertionTorque,
      });
    }

    if (this.props.instrumentId) {
      this.props.actions.subscribeToReceviedMeasurement(this.props.instrumentId);
      this.setState({
        instrumentId: this.props.instrumentId,
      });
    }

    //Received Beacon status
    if (this.props.show && this.props.activeInstrument.NextDirr) {
      this.setState({
        nextDir: this.props.activeInstrument.NextDir,
      });
    }

    if (this.props.measurement) {
      this.setState({
        timeStamp: new Date(this.props.measurement.date),
        isqBl: this.props.measurement.BL,
        isqMd: this.props.measurement.MD,
        level: this.props.measurement.level,
        smartPegLot: this.props.measurement.smartPegLot ?? '',
        smartPegType: this.props.measurement.smartPegType ?? 'NoSelection'
      });
    } else if (this.props.editable) {
      this.setState({
        timeStamp: new Date(),
      });
    }
  }

  componentWillUnmount() {
    if (this.state.instrumentId) {
      this.props.actions.unsubscribeToReceviedMeasurement(this.state.instrumentId);
    }
    if (window.ReactNativeWebView) {
      window.removeEventListener('barcode', this.boundOnScan, true);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show && nextProps.implant && !this.props.show) {
      let type = undefined;
      if (nextProps.measurement?.type === 'DuringPlacement') type = 'Placement';
      else if (
        nextProps.measurement?.type === 'DuringFollowup' ||
        nextProps.measurement?.type === 'DuringLoading'
      )
        type = 'Followup';
      this.setState({
        session: type,
        finalRestoration: nextProps.measurement
          ? nextProps.measurement.type === 'DuringLoading'
          : nextProps.implant.measurements.some((x) => x.type === 'DuringLoading'),
        loadingProtocol: nextProps.implant.loadingProtocol,
        surgicalProtocol: nextProps.implant.surgicalProtocol,
        insertionTorque: nextProps.implant.insertionTorque,
      });
    }

    if (nextProps.createMeasurement.complete && this.createMeasurement) {
      this.createMeasurement = false;
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({ id: 'measurement.saved', defaultMessage: 'Measurement saved' }),
        toastrOptions
      );
      this.hideCreateMeasurementModal();
      return;
    }

    if (
      (nextProps.createMeasurement.error && this.createMeasurement) ||
      (nextProps.deleteMeasurement.error && this.deletingMeasurement)
    ) {
      this.createMeasurement = false;
      this.deletingMeasurement = false;

      const error = nextProps.createMeasurement.error || nextProps.deleteMeasurement.error;

      error &&
        error.messages.forEach((m) =>
          toastr.error(
            this.intl.formatMessage({ id: 'general.error', defaultMessage: 'Error' }),
            this.intl.formatMessage({ id: m.text }),
            toastrOptions
          )
        );
    }

    if (nextProps.deleteMeasurement.complete && this.deletingMeasurement) {
      this.deletingMeasurement = false;
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({
          id: 'measurement.deleted',
          defaultMessage: 'Measurement deleted',
        }),
        toastrOptions
      );
      this.hideCreateMeasurementModal();
      return;
    }

    if (nextProps.instrumentId !== this.state.instrumentId && nextProps.show) {
      if (this.state.instrumentId) {
        this.props.actions.unsubscribeToReceviedMeasurement(this.state.instrumentId);
      }
      this.props.actions.subscribeToReceviedMeasurement(nextProps.instrumentId);
      this.setState({
        instrumentId: nextProps.instrumentId,
      });
    }

    if (this.props.show) {
      //Received Beacon measurement
      if (
        nextProps.receivedMeasurement &&
        (!this.props.receivedMeasurement ||
          nextProps.receivedMeasurement.Ct !== this.props.receivedMeasurement.Ct)
      ) {
        if (nextProps.receivedMeasurement.Dir === 'BL') {
          this.setState({
            isqBl: nextProps.receivedMeasurement.Isq,
            timeStamp: new Date(),
            instrumentIdMeasured: nextProps.instrumentId,
            updatedDir: 'BL',
            nextDir: undefined,
          });
        } else if (nextProps.receivedMeasurement.Dir === 'MD') {
          this.setState({
            isqMd: nextProps.receivedMeasurement.Isq,
            timeStamp: new Date(),
            instrumentIdMeasured: nextProps.instrumentId,
            updatedDir: 'MD',
            nextDir: undefined,
          });
        }
      }
    }

    //Received Beacon status
    if (nextProps.show && nextProps.activeInstrument.NextDir !== this.state.nextDir) {
      this.setState({
        nextDir: nextProps.activeInstrument.NextDir,
      });
    }

    if (nextProps.measurement && !this.props.measurement) {
      this.setState({
        timeStamp: new Date(nextProps.measurement.date),
        isqBl: nextProps.measurement.BL,
        isqMd: nextProps.measurement.MD,
        level: nextProps.measurement.level,
        smartPegLot: nextProps.measurement.smartPegLot ?? '',
      });
    } else if (!this.props.show && nextProps.show && nextProps.editable) {
      this.setState({
        timeStamp: new Date(),
      });
    }
  }

  hideCreateMeasurementModal() {
    if (this.state.instrumentId) {
      this.props.actions.unsubscribeToReceviedMeasurement(this.state.instrumentId);
    }
    this.setState({
      isqBl: '',
      isqMd: '',
      updatedDir: undefined,
      nextDir: undefined,
      timeStamp: undefined,
      level: 'Implant',
      selectedOption: undefined,
      instrumentId: undefined,
      instrumentIdMeasured: undefined,
      insertionTorque: -1,
      session: undefined,
      loadingProtocol: 'NoSelection',
      surgicalProtocol: 'NoSelection',
      smartPegType: 'NoSelection',
      finalRestoration: false,
      smartPegLot: '',
    });

    if (this.props.hide) {
      this.props.hide();
    }
  }

  insertionTorqueChanged(evt) {
    let value = evt.target.value;
    if (value.length === 0 || !Number(value)) value = undefined;

    this.setState({
      insertionTorque: value,
    });
  }

  sessionChanged(evt) {
    if (evt.target.value === 'Placement') {
      this.setState({
        finalRestoration: false,
      });
    }
    this.setState({
      session: evt.target.value,
    });
  }

  levelChanged(evt) {
    let value = evt.target.value;
    if (value.length === 0) value = undefined;

    this.setState({
      level: value,
    });
  }

  isqChanged(dir, value) {
    if (dir === 'BL') {
      this.setState({
        isqBl: value,
      });
    } else if (dir === 'MD') {
      this.setState({
        isqMd: value,
      });
    }
  }

  timeStampChanged(date) {
    this.setState({
      timeStamp: date,
    });
  }

  loadingProtocolChanged(evt) {
    this.setState({
      loadingProtocol: evt.target.value,
      surgicalProtocol: evt.target.value === 'ConventionalLoading' ? 'TwoStage' : 'OneStage',
    });
  }

  surgicalProtocolChanged(evt) {
    this.setState({
      surgicalProtocol: evt.target.value,
    });
  }

  smartPegTypeChanged(evt) {
    this.setState({
      smartPegType: evt.target.value,
    });
  }

  finalRestorationChanged(evt) {
    this.setState({
      finalRestoration: evt.target.value === 'Yes',
    });
  }

  lotChanged(evt) {
    this.setState({
      smartPegLot: evt.target.value,
    });
  }

  onScan(e) {
    var barcodeFromEvent = e.detail;
    var barCode = barcodeFromEvent.replace('\x1D', '').trim();
    var result;
    try {
      result = gs1Parser(barCode);
    } catch (error) {
      this.lotChanged({ target: { value: '' } });
      this.setState({
        errorMessages: {
          messages: [
            {
              text: this.intl.formatMessage({
                id: 'addimplant.noMatchOnScan2',
                defaultMessage: `No barcode standard we support was detected.`,
              }),
              id: 'NoMatch',
            },
          ],
        },
      });

      appInsights.trackEvent({
        name: 'ScannedSmartPegFail',
        properties: {
          barCode: barCode,
          parsedLotNumber: false,
          parsingSuccess: false,
          userId: this.props.user.userId,
          email: this.props.user.email,
        },
      });
      return;
    }

    var scannedSmartPegSuccess = false;

    try {
      const lotNumberElement = result.parsedCodeItems.find((parsedItem) => parsedItem.ai === '10');
      this.lotChanged({ target: { value: lotNumberElement.data } });
      this.setState({
        errorMessages: undefined,
      });

      scannedSmartPegSuccess = true;
    } catch {
      scannedSmartPegSuccess = false;

      this.lotChanged({ target: { value: '' } });
      this.setState({
        errorMessages: {
          messages: [
            {
              text: this.intl.formatMessage({
                id: 'measurement.noLotNrFoundWhenScanning',
                defaultMessage: 'Could not find a lotnumber in that barcode.',
              }),
              id: 'NoMatch',
            },
          ],
        },
      });

      appInsights.trackEvent({
        name: 'ScannedSmartPegFail',
        properties: {
          barCode: barCode,
          parsedLotNumber: false,
          parsingSuccess: true,
          userId: this.props.user.userId,
          email: this.props.user.email,
        },
      });
    }

    if (scannedSmartPegSuccess) {
      appInsights.trackEvent({
        name: 'ScannedSmartPegSuccess',
        properties: {
          barCode: barCode,
          userId: this.props.user.userId,
          email: this.props.user.email,
        },
      });
    }
  }

  saveMeasurement() {
    if (
      this.state.isqBl.length === 0 ||
      this.state.isqMd.length === 0 ||
      this.props.selectedTooth <= 0
    )
      return;

    let type = 'Unknown';

    if (this.state.session === 'Placement') type = 'DuringPlacement';
    else if (this.state.finalRestoration) type = 'DuringLoading';
    else type = 'DuringFollowup';

    this.createMeasurement = true;
    this.props.actions.createMeasurement(
      this.props.patient.sourceUserGroupId,
      this.props.patient.id,
      this.props.selectedTooth,
      this.state.isqBl,
      this.state.isqMd,
      type,
      this.state.level,
      this.state.timeStamp,
      this.state.instrumentIdMeasured,
      this.props.measurement ? this.props.measurement.id : null,
      this.state.loadingProtocol,
      this.state.surgicalProtocol,
      this.state.insertionTorque,
      this.state.smartPegType,
      this.state.smartPegLot,
      this.props.implant.measurements
    );
  }

  deleteMeasurementRequest() {
    const content = (
      <div>
        <p>
          {this.intl.formatMessage({
            id: 'measurement.DeleteConfirmation',
            defaultMessage: 'Are you sure your want to delete the measurement?',
          })}
        </p>
      </div>
    );
    this.props.actions.showConfirmation(
      this.intl.formatMessage({
        id: 'measurement.DeleteMeasurement',
        defaultMessage: 'Delete Measurement',
      }),
      content,
      this.deleteMeasurement
    );
  }

  deleteMeasurement() {
    this.deletingMeasurement = true;

    this.props.actions.deleteMeasurement(
      this.props.patient.sourceUserGroupId,
      this.props.patient.id,
      this.props.selectedTooth,
      this.props.measurement.id,
      this.props.implant.measurements
    );
  }

  disableSave() {
    const { session, isqBl, isqMd, surgicalProtocol, loadingProtocol, smartPegType } = this.state;
    const isCreating = this.createMeasurement;
    const missingSession = !session;
    const missingISQ = !isqBl || !isqMd;
    const missingProtocols =
      surgicalProtocol === 'NoSelection' || loadingProtocol === 'NoSelection';
    const missingSmartPeg = smartPegType === 'NoSelection';
    return isCreating || missingSession || missingISQ || missingProtocols || missingSmartPeg;
  }

  render() {
    const error = this.state.errorMessages;
    let content = (
      <div className={styles.content}>
        <div className={styles.column}>
          <InputRow>
            <InputItem
              dataCy="create-measurement-modal-session-input"
              label={
                '*' +
                this.intl.formatMessage({
                  id: 'measurement.measurementSession',
                  defaultMessage: 'Measurement Session',
                })
              }
              type="selectbutton"
              onChange={this.sessionChanged}
              options={this.sessionOptions}
              value={this.state.session}
              centered
              span
              onWhite
            />
          </InputRow>
          <div className={styles.timestamp}>
            <InputItem
              className={styles.date}
              label={'*' + this.intl.formatMessage({ id: 'general.date', defaultMessage: 'Date' })}
              value={this.state.timeStamp}
              type="date"
              onChange={this.timeStampChanged}
              onWhite
              timeVisible={true}
            />
          </div>
          <InputRow>
            <InputItem
              label={
                '*' +
                this.intl.formatMessage({
                  id: 'measurement.measurementLevel',
                  defaultMessage: 'Measurement level',
                })
              }
              type="selectbutton"
              onChange={this.levelChanged}
              options={this.levelOptions}
              value={this.state.level}
              centered
              span
              onWhite
            />
          </InputRow>
          <InputSubGroup
            className={styles.measurementWrapper}
            label={
              '*' +
              this.intl.formatMessage({
                id: 'measurement.enterISQ',
                defaultMessage: 'Measure or enter ISQ manually',
              })
            }
          >
            <div className={styles.isqWrapper}>
              <ISQItem
                dataCy="create-measurement-modal-input-bl"
                size="medium"
                editable={this.props.editable}
                direction="BL"
                isq={this.state.isqBl}
                isqChanged={this.isqChanged}
                active={this.state.nextDir === 'BL'}
                updated={this.state.updatedDir === 'BL'}
                abutment={this.state.level === 'Abutment'}
              />
              <ISQItem
                dataCy="create-measurement-modal-input-md"
                size="medium"
                editable={this.props.editable}
                direction="MD"
                isq={this.state.isqMd}
                isqChanged={this.isqChanged}
                active={this.state.nextDir === 'MD'}
                updated={this.state.updatedDir === 'MD'}
                abutment={this.state.level === 'Abutment'}
              />
            </div>
            <div
              className={cn(
                styles.instrumentStatus,
                this.props.instrumentId ? styles.online : null
              )}
            >
              {this.props.instrumentId ? (
                <FormattedMessage
                  id="measurement.activeInstrument"
                  defaultMessage="Beacon connected, ready to measure"
                />
              ) : (
                <FormattedMessage
                  id="measurement.noActiveInstrument"
                  defaultMessage="No active instrument"
                />
              )}
            </div>
            <div className={styles.isqInfoIcon}>
              <IsqInfoModal />
            </div>
            {this.state.level === 'Abutment' && (
              <div className={styles.abutmentNote}>
                *{' '}
                <FormattedMessage
                  id="patient.abutmentNote"
                  defaultMessage="The ISQ on abutment level will not be equal to measuring on implant level and should be used as a relative ISQ value for tracking the implant stability."
                />
              </div>
            )}
          </InputSubGroup>
        </div>
        <div className={styles.column}>
          {this.state.session === 'Placement' && (
            <InputRow>
              <InputItem
                dataCy="create-measurement-modal-input-max-insertion"
                label={this.intl.formatMessage({
                  id: 'measurement.maximumInsertionTorque',
                  defaultMessage: 'Maximum Insertion Torque (Ncm)',
                })}
                type="text"
                value={this.state.insertionTorque > 0 ? this.state.insertionTorque : ''}
                onChange={this.insertionTorqueChanged}
                onWhite
              />
            </InputRow>
          )}
          {error ? (
            <AlertBox
              color="black"
              headerText={this.intl.formatMessage({
                id: 'general.generalError',
                defaultMessage: 'Oops, there was an error',
              })}
              messages={error.messages.map((m) => m.text)}
            />
          ) : null}
          <InputRow className={styles.scanRow}>
            <InputItem
              dataCy="create-measurement-modal-input-lotnumber"
              label={this.intl.formatMessage({
                id: 'measurement.batchLotNumber',
                defaultMessage: 'SmartPeg Batch/Lot Number',
              })}
              type="text"
              value={this.state.smartPegLot}
              onChange={(e) => {
                this.lotChanged(e);
                this.setState({
                  errorMessages: undefined,
                });
              }}
              onWhite
            />
            {window.ReactNativeWebView && (
              <div
                className={styles.scanButton}
                onClick={() => {
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                      type: 'startscan',
                      scanText: this.intl.formatMessage({
                        id: 'app.scanSmartPeg',
                        defaultMessage: 'Scan the SmartPeg QR-code',
                      }),
                    })
                  );
                }}
              >
                <SvgBarcodeliga width={'40'} />
              </div>
            )}
          </InputRow>
          <InputRow>
            <InputItem
              label={
                '*' +
                this.intl.formatMessage({
                  id: 'measurement.loadingProtocol',
                  defaultMessage: 'Loading Protocol',
                })
              }
              type="selectbutton"
              options={this.props.loadingProtocols.map((x) => ({
                key: x.key,
                value: this.intl.formatMessage({ ...x.label }),
              }))}
              value={this.state.loadingProtocol}
              onChange={this.loadingProtocolChanged}
              centered
              onWhite
              span
            />
          </InputRow>
          <InputRow>
            <InputItem
              label={
                '*' +
                this.intl.formatMessage({
                  id: 'measurement.surgicalProtocol',
                  defaultMessage: 'Surgical Protocol',
                })
              }
              type="selectbutton"
              options={this.props.surgicalProtocols.map((x) => ({
                key: x.key,
                value: this.intl.formatMessage({ ...x.label }),
              }))}
              value={this.state.surgicalProtocol}
              onChange={this.surgicalProtocolChanged}
              centered
              onWhite
              span
            />
          </InputRow>
          <InputRow>
            <InputItem
              label={
                '*' +
                this.intl.formatMessage({
                  id: 'measurement.smarPegType',
                  defaultMessage: 'SmartPeg',
                })
              }
              type="selectbutton"
              options={this.props.smartPegTypes.map((x) => ({
                key: x.key,
                value: this.intl.formatMessage({ ...x.label }),
              }))}
              value={this.state.smartPegType}
              onChange={this.smartPegTypeChanged}
              centered
              onWhite
              span
            />
          </InputRow>
          {this.state.session === 'Followup' && (
            <InputRow>
              <InputItem
                type="selectbutton"
                label={this.intl.formatMessage({
                  id: 'measurement.prostheticDecision',
                  defaultMessage: 'Prosthetic Decision: Ready for final restoration?',
                })}
                options={this.restorationOptions}
                value={this.state.finalRestoration ? 'Yes' : 'No'}
                onChange={this.finalRestorationChanged}
                centered
                onWhite
                span
              />
            </InputRow>
          )}
        </div>
      </div>
    );
    return (
      <Modal
        header={this.intl.formatMessage({
          id: 'measurement.addMeasurement',
          defaultMessage: 'Add measurement',
        })}
        onDismiss={this.hideCreateMeasurementModal}
        show={this.props.show}
      >
        {content}
        <div className={styles.mandatoryFields}>
          <em>
            * <FormattedMessage id="general.mandatoryFields" defaultMessage="Mandatory fields" />
          </em>
        </div>
        <div className={styles.buttons}>
          {this.props.measurement ? (
            <Button
              value={this.intl.formatMessage({ id: 'general.delete', defaultMessage: 'Delete' })}
              onClick={this.deleteMeasurementRequest}
              disabled={this.deletingMeasurement}
              loading={this.deletingMeasurement}
            />
          ) : null}
          <Button
            value={this.intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancel' })}
            onClick={() => this.hideCreateMeasurementModal()}
          />
          <Button
            dataCy="create-measurement-modal-save-button"
            primary
            value={this.intl.formatMessage({ id: 'general.save', defaultMessage: 'Save' })}
            onClick={this.saveMeasurement}
            disabled={this.disableSave()}
            loading={this.createMeasurement}
          />
        </div>
      </Modal>
    );
  }
}

function mapState(state) {
  return {
    user: state.user.user,
    patient: state.patient.currentPatient,
    selectedTooth: state.patient.selectedPatientImplant,
    createMeasurement: state.patient.createMeasurement,
    deleteMeasurement: state.patient.deleteMeasurement,
    receivedMeasurement: state.patient.receivedMeasurement,
    activeInstrument: state.instrument.activeInstrument,
    loadingProtocols: state.referenceData.loadingProtocols,
    surgicalProtocols: state.referenceData.surgicalProtocols,
    smartPegTypes: state.referenceData.smartPegTypes,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators(
      { ...patientActions, ...instrumentActions, ...generalActions },
      dispatch
    ),
  };
}

export default connect(mapState, mapDispatch)(injectIntl(CreateMeasurementModal));
